import { ArrowLeftOutlined } from '@ant-design/icons';
import { useRouter } from 'next/router';
import { Col, Row } from 'reactstrap';
import MockTestItemGrid from './MockTestItemList';
import MockTestSidebar from './MockTestSidebar';
import { memo } from 'react';

const MockTestByCourseList = ({
  total,
  loading,
  isCourseDetailComponent,
  courseSlug,
}) => {
  const router = useRouter();

  return (
    <div
      className="main-wrapper mock-test-page"
      style={{ backgroundColor: ' #F0F2F5' }}
    >
      {/* Course Grid */}
      <section className="mock-test-grid-area py-4 ">
        <div className="custom-container">
          <Row>
            <div className="mb-4">
              <button
                type="button"
                className="btn btn-primary border-primary mr-3  d-flex align-items-center gap-2"
                onClick={() => {
                  router.back();
                }}
              >
                <ArrowLeftOutlined rev="" style={{ fontSize: '15px' }} />
                Back
              </button>
            </div>
            <Col lg="3" md="4" sm="12">
              <MockTestSidebar component="Tests" courseSlug={courseSlug} />
            </Col>
            <Col lg="9" md="8" sm="12">
              <div className="course-items">
                <Row>
                  <MockTestItemGrid
                    total={total}
                    loading={loading}
                    isCourseDetailComponent={isCourseDetailComponent}
                    courseSlug={courseSlug}
                  />
                </Row>
              </div>
            </Col>
          </Row>
        </div>
      </section>
    </div>
  );
};

export default memo(MockTestByCourseList);
